import Vue from 'vue';
import Router from 'vue-router';
import Layout from '@/layout/index.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Users from '@/views/Users.vue';
import Catalog from '@/views/Catalog.vue';
import Audit from '@/views/Audit.vue';
import ModulePage from '@/views/ModulePage.vue';
import MessageDetail from '@/views/MessageDetail.vue';
import Square from '@/views/Square.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { title: '登录' }
    },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', name: 'home', component: Home, meta: { title: '首页' } },
        { path: 'users', name: 'users', component: Users, meta: { title: '用户管理' } },
        { path: 'audit', name: 'audit', component: Audit, meta: { title: '商品审核' } },
        { path: 'catalog', name: 'catalog', component: Catalog, meta: { title: '商品管理' } },
        { path: 'categories', component: ModulePage, meta: { title: '分类管理', module: 'categories' } },
        { path: 'banners', component: ModulePage, meta: { title: 'Banner 管理', module: 'banners' } },
        { path: 'comments', component: ModulePage, meta: { title: '评论管理', module: 'comments' } },
        { path: 'square', component: Square, meta: { title: '广场管理' } },
        { path: 'orders', component: ModulePage, meta: { title: '订单管理', module: 'orders' } },
        { path: 'messages', component: ModulePage, meta: { title: '消息管理', module: 'messages' } },
        { path: 'messages/:id', component: MessageDetail, meta: { title: '消息详情' } },
        { path: 'reports', component: ModulePage, meta: { title: '举报管理', module: 'reports' } },
        { path: 'feedback', component: ModulePage, meta: { title: '建议反馈', module: 'feedback' } }
      ]
    }
  ]
});
